<div class="auth-page-container p-2">
  <h2 mat-dialog-title class="join-header px-4">{{'signIn' | translate}}
    <button class="btn float-end form-close-btn" (click)="closeDialog()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.4 15L10 11.4L13.6 15L15 13.6L11.4 10L15 6.4L13.6 5L10 8.6L6.4 5L5 6.4L8.6 10L5 13.6L6.4 15ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
          fill="#BAB5B5" />
      </svg>
    </button>
  </h2>
  <hr class="mt-0 mb-2" />
  <p class="px-4 mb-0 login-sb-hed">
    {{'welcomeBack' | translate}} <br>
    {{'yourNext' | translate}}
  </p>
  <mat-dialog-content class="mat-typography join-box-body">
    <form class="join-form-box" [formGroup]="loginForm" (ngSubmit)="onSubmitLoginForm()">
      <div class="registration-form w-100">
        <div class="row">
          <section class="col-md-12 col-sm-12">
            <div class="form-group mb-2">
              <label for="exampleFormControlInput1" class="form-label">{{'email' | translate}}</label>
              <section>
                <div class="input-group"
                  [ngClass]="{'border-danger':  this.sharedService.isFieldInvalid('email', loginForm)}">
                  <span class="input-group-text" id="basic-addon1">
                    <mat-icon>type_specimen</mat-icon>
                  </span>
                  <input type="text" class="form-control" spellcheck="false" [placeholder]="'typeHere' | translate" formControlName="email">
                </div>
              </section>
            </div>
          </section>
          <section class="col-md-12 col-sm-12">
            <div class="form-group mb-2">
              <label for="exampleFormControlInput1" class="form-label">{{'password' | translate}}</label>
              <section>
                <div class="input-group"
                  [ngClass]="{'border-danger': this.sharedService.isFieldInvalid('password', loginForm)}">
                  <span class="input-group-text" id="basic-addon1">
                    <mat-icon>password</mat-icon>
                  </span>
                  <input [type]="!showPassword ? 'password':'text'" class="form-control"
                    [placeholder]="'typeHere' | translate" formControlName="password" spellcheck="false">
                  <span class="input-group-text cursor-pointer" (click)="openPassword()"
                    *ngIf="showPassword"><mat-icon>remove_red_eye</mat-icon></span>
                  <span class="input-group-text cursor-pointer" (click)="openPassword()" *ngIf="!showPassword">
                    <mat-icon>visibility_off</mat-icon></span>
                </div>
              </section>
            </div>
          </section>
          <section class="captcha-container col-md-12 mt-2 px-2" id="login-box">
            <!-- <ngx-recaptcha2 #captchaComponent [hl]="cultureLanguage" [siteKey]="recaptchaSiteKey" [size]="'normal'" [theme]="'light'" (success)="handleSuccess($event)" (error)="handleError()" (expire)="handleExpired()">
            </ngx-recaptcha2> -->
                  <app-turnstile
                        formControlName="reCaptcha"
                        #turnstile
                        (verified)="onVerified($event)"
                        (expired)="onExpired()"
                        (errored)="onExpired()"
                    ></app-turnstile>
          </section>
          <div class="col-md-12 forgotPassword">
            <a class="common-link" (click)="openForgotPassword()">{{'forgotPassword' | translate}}</a>
          </div>
          @if (!isShowLoader) {
          <section class="form-action col-md-12 mt-1">
            <button type="submit" mat-stroked-button class="proceed-button form-control">{{'proceed' |
              translate}}</button>
          </section>
          }
          @if (isShowLoader) {
          <section class="form-action col-md-12 mt-1">
            <button class="proceed-button form-control" type="button" disabled>
              <span class="spinner-border spinner-border-sm mx-2" aria-hidden="true"></span>
              <span role="status">{{'loading' | translate}}</span>
            </button>
          </section>
          }
          <div class="col-md-12 text-center mt-2">
            <span>{{'noAccount' | translate}}</span> <a class="sign-link" (click)="openSignUpPage()"> {{'signUp' | translate}}</a>
          </div>
        </div>
      </div>

    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="center" class="mt-2">
    <div class="download-app">
      <!-- <section class="d-flex justify-content-center">
              <div id="googleSignInDiv"></div>
            </section> -->
      <a href="https://play.google.com/store/apps/details?id=com.unipanel&pli=1" target="_blank">
        <img src="../../../../../assets/images/playstore.png" alt="downlaod-with-playstore">
      </a>
      <a href="https://apps.apple.com/us/app/opinion-edge/id6446476343" target="_blank">
        <img src="../../../../../assets/images/App-Store.png" alt="downlaod-with-appstore">
      </a>
    </div>
  </mat-dialog-actions>
</div>